import React, {useState} from 'react'

import Chart from 'react-apexcharts'

import './charts.css'

const DonutChart = () => {
    //process what you will add here
    // look at your selectorStates
    // pass in the totalNumber in the series against the actual record number
    return (
        <>
            <Chart //This is going to be dynamically generated and it is going to be total against actual data
                type="donut"
                width={80}
                height={80}
                // padding={10}
                series={[80, 200]}
                options={{
                    legend: {
                        show: false,
                    }, 

                    labels: ['Jan', 'Feb'],
                    dataLabels: {enabled: false}
                }}
            />
        </>
    )
}

const Charts = () => {
    // types of chart = line, bar, area, pie, radar, donut
    const [series, setSeries]: any    = useState({
        // chart: {
        //     id: "basic-bar"
        //   },
        series: [
            {
                name: 'Hexagon Products',
                data: [80, 200, 310, 350, 500, 600],
                color: '#282c34',
                labels: ['A', 'B', 'C', 'D', 'E', 'F']
            },
            {
                name: 'Hexagon Sales',
                data: [100, 200, 300, 400, 430, 200],
                labels: ['A', 'B', 'C', 'D', 'E', 'F']
            }
        ],
        options: {
            chart: {
            height: 350,
            type: 'area'
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          xaxis: {
            type: 'datetime',
            categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
          },
        },
    })

  return (
    <>
        <div className='charts-main'>
            <Chart
                // type="area"
                width={300}
                height={300}
                series={series.series}
                options={series.options}
            />
        </div>
        
        <div className='charts-main'>
            <Chart 
                type="pie"

                title="Properties for sale"
                value="500"

                width={300}
                height={300}
                series={[80, 200, 310, 350]}
                options={{
                    legend: {
                        show: true,
                        position: 'right'
                    },
                    labels: ['Jan', 'Feb', 'Mar', 'Apr'],
                }}
            />
        </div>
    </>
  )
}

export {
    DonutChart,
    Charts
}